/** Marketing slug for the 30-minute program landing page */
export const LOP30_PROGRAM_SLUG = 'lop-30-minutter';

/** Signup campaign slug sent to the API when registering from the landing page */
export const LOP30_SIGNUP_CAMPAIGN = 'lop-30-minutter';

export const CREATE_ACCOUNT_LOP30_URL = `/create-account?campaign=${LOP30_SIGNUP_CAMPAIGN}`;

const frontendBase = process.env.REACT_APP_FRONTEND_URL || 'https://lopeglad.no';

/** Program id for «Løp 30 minutter» in the app */
export const LOP30_PROGRAM_ID = process.env.REACT_APP_LOP30_PROGRAM_ID || '47';

export function getLop30ProgramDeepLink() {
  if (LOP30_PROGRAM_ID) {
    return `lopeglad://programs/${LOP30_PROGRAM_ID}`;
  }
  return `lopeglad://program/${LOP30_PROGRAM_SLUG}`;
}

export function getLop30ProgramUniversalUrl() {
  if (LOP30_PROGRAM_ID) {
    return `${frontendBase}/programs/${LOP30_PROGRAM_ID}`;
  }
  return `${frontendBase}/program/${LOP30_PROGRAM_SLUG}`;
}
